globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Websites = appCustomerSpace.Modals.Websites || {};

appCustomerSpace.Modals.Websites.LibraryBlogArticles = (function(superClass) {

  utils.extend(LibraryBlogArticles, superClass);

  function LibraryBlogArticles($html) {
    this.$html = $html;

    return LibraryBlogArticles.__super__.constructor.apply(this, arguments);
  }

  $.extend(LibraryBlogArticles.prototype, {
    init: function() {
      this.initEvents();

      return LibraryBlogArticles.__super__.init.apply(this, arguments);
    },
    initEvents: function() {
      var modal = this;

      var $modal = $('.modal');

      $modal.find('.submit-form-button').on('click', function() {
        var $container = $modal.find('.modal-content');
        var form = $modal.find('form.edit_cms_blog_blog');
        var url = form.attr('action');

        appCustomerSpace.Loader().start({ $container: $container });

        if (url) {
          $.ajax({
            type: "PATCH",
            url: url,
            data: new FormData(form[0]),
            processData: false,
            contentType: false,
            success: function(data)
            {
              if (data.response == 1) {
                modal.close();
                appCustomerSpace.Loader().stop({ $container: $container });
                location.reload();
              } else {
                modal.close();
                appCustomerSpace.Loader().stop({ $container: $container });
                location.reload();
              }
            }
          })
        }
      });

      $modal.find('.tag-filter').on('change', function() {
        modal._filterLibraryArticles($(this).closest('form'));
      })

      $modal.find('input[type=search]').on('change', function() {
        modal._filterLibraryArticles($(this).closest('form'));
      })
    },
    _filterLibraryArticles: function(form) {
      var $modal = $('.modal');
      var $container = $modal.find('.library-articles-list');
      var url = form.attr('action');

      appCustomerSpace.Loader().start({ $container: $container, options: {text: false} });

      if (url) {
        $.ajax({
          type: "GET",
          url: url,
          data: form.serialize(),
          success: function(data)
          {
            if (data.response == 1) {
              $container.html(data.views.thumbnail_view);
              appCustomerSpace.Loader().stop({ $container: $container });
              appCustomerSpace.LimitlessPlugins.Checkbox.init($container);
            } else {
              appCustomerSpace.Loader().stop({ $container: $container });
            }
          }
        })
      }
    }
  });

  return LibraryBlogArticles;

})(appCustomerSpace.Modal);
